import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Check Bold".
 *
 * @property {string} [tooltip] - The tooltip to display on hover.
 */
@Component({
    selector: 'app-icon-check-bold',
    templateUrl: './icon-check-bold.component.html',
    styleUrls: ['./icon-check-bold.component.scss'],
    standalone: false
})
export class IconCheckBoldComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
